import { configureApiEntity } from '../adapter';
import { schema } from 'normalizr';

export const vatTypeSchema = new schema.Entity('vatTypes');

export const vatTypes = configureApiEntity('VATTYPES', 'vattypes', vatTypeSchema);
